import { createContext, useContext } from "react"

/**
 * All known feature keys — keep in sync with
 * packages/cms/src/features/manifest.ts FEATURE_KEYS.
 */
export const FEATURE_KEYS = [
  "aoi",
  "emergencyApplications",
  "automatedApproval",
  "surveys",
  "clientCompanyColumn",
  "externalApi",
] as const
export type FeatureKey = (typeof FEATURE_KEYS)[number]

export type FeatureContextValue = {
  /** Raw feature map fetched from the server. null while loading or unauthenticated. */
  features: Record<string, boolean | number | string> | null
  /** True while the myOrgFeatures query is in-flight. Gate navigation on this to avoid flash. */
  isFeaturesLoading: boolean
  /** Re-fetch entitlements from the server, bypassing the Apollo cache. */
  refetchFeatures: () => Promise<unknown>
}

export const defaultFeatureContextValue: FeatureContextValue = {
  features: null,
  isFeaturesLoading: true,
  refetchFeatures: async () => undefined,
}

export const FeatureContext = createContext<FeatureContextValue>(defaultFeatureContextValue)

export function useFeatureContext(): FeatureContextValue {
  return useContext(FeatureContext)
}
